import React from 'react';
import propTypes from 'prop-types';

export default function PlusIcon(props) {
  const { className } = props;
  return (
    <svg
      className={className}
      version="1.1"
      id="Layer_2"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="20px"
      height="20px"
      viewBox="0 0 20 20"
      style={{ enableBackground: 'new 0 0 20 20' }}
      xmlSpace="preserve"
    >
      <title>New Folder</title>
      <rect x="1" y="9" width="18" height="2" />
      <rect x="9" y="1" width="2" height="18" />
    </svg>
  );
}
PlusIcon.propTypes = {
  className: propTypes.string,
};
